import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";
import {
  getMenuItems,
  fixSaleNoIngredients,
} from "../../../Redux/actions/dailysalesActions";

import { getProduct } from "../../../Redux/actions/productActions";
import { setProductInventoryWithLocation } from "../../../Redux/actions/inventoryActions";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onModalClose, currentSalesOrder }) => {
  const dispatch = useDispatch();
  const { menuitems } = useSelector(
    (state) => ({
      menuitems: state.dailysales.menuitems,
    }),
    shallowEqual
  );

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [itemcount, setItemcount] = useState({});
  const [itemcount_reg, setItemcount_reg] = useState({});

  const [createDate, setCreatedDate] = useState(moment());

  useEffect(() => {}, []);

  useEffect(() => {
    if (currentSalesOrder) {
      dispatch(getMenuItems());
    }
  }, [currentSalesOrder]);

  useEffect(() => {
    if (menuitems) {
      docategorized();
      console.log(menuitems);
    }
  }, [menuitems]);

  const docategorized = () => {
    var categories = [];

    menuitems.map((it) => {
      if (!categories.includes(it.category_name)) {
        categories.push(it.category_name);
      }
    });
    var newcats = [];
    categories.map((ct) => {
      var catprods = [];
      menuitems.map((it) => {
        if (ct == it.category_name) {
          catprods.push(it);
        }
      });
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
      };
      newcats.push(newcatp);
    });

    console.log(newcats);
    setCategorized(newcats);
  };

  const summarizeSale = () => {
    console.log("currentSalesOrder", currentSalesOrder);
    var thisitemcount = currentSalesOrder.products_sold;
    var ingredient_ids = [];
    var ingredients_base = [];
    var ingredients_count = [];

    var products_sold = [];
    console.log("thisitemcount", thisitemcount);

    console.log("menuitems", menuitems);

    thisitemcount.map((item) => {
      console.log(item);
      var item_id = item.id;
      var item_quantity = item.quantity_sold;

      if (item_quantity > 0) {
        var current_prod = menuitems.filter((x) => x.key == item_id);
        if (current_prod[0]) {
          current_prod = current_prod[0];
          console.log("current_prod menu item", current_prod);
          var recorded_product = {
            ...current_prod,
            ...item,
            ingredients: current_prod.ingredients,
          };

          products_sold.push(recorded_product);
        }
        if (current_prod.ingredients) {
          current_prod.ingredients.map((ingrd) => {
            var new_ingrd = {
              ...ingrd,
              quantity: parseFloat(ingrd.quantity) * parseFloat(item_quantity),
            };
            ingredients_count.push(new_ingrd);

            if (!ingredient_ids.includes(new_ingrd.product)) {
              var ind_base = {
                product: new_ingrd.product,
                product_name: new_ingrd.product_name,
              };
              ingredient_ids.push(new_ingrd.product);
              ingredients_base.push(ind_base);
            }
          });
        }
      }
    });

    // console.log(ingredients_base)
    // console.log(ingredients_count)

    var ingredient_final = [];

    ingredients_base.map((ingd) => {
      var all_has = ingredients_count.filter((i) => i.product == ingd.product);

      var product_total = 0;
      all_has.map((same_prod) => {
        product_total = product_total + parseFloat(same_prod.quantity);
      });

      var new_count = {
        ...ingd,
        quantity: product_total,
      };

      ingredient_final.push(new_count);
    });

    // console.log('products_sold',products_sold)
    if (products_sold.length > 0) {
      // console.log("ingredient_final", ingredient_final);
      // console.log("products_sold", products_sold);

      addingredientstosale(products_sold, ingredient_final);
    } else {
      message.warning("select item");
    }
  };

  const addingredientstosale = async (products_sold, ingredient_final) => {
    console.log("products_sold", products_sold);
    console.log(ingredient_final);

    if (!loading) {
      setLoading(true);
      message.info("recording sales");
      var save_ingredients = [];
      await Promise.all(
        ingredient_final.map(async (indx, i) => {
          console.log("ingredietns_final", indx);
          var product3 = await dispatch(
            setProductInventoryWithLocation(
              indx.product,
              indx.product_name,
              indx.quantity,
              "subtract",
              `used (from ${currentSalesOrder.sale_date} )`,
              currentSalesOrder.branch,
              currentSalesOrder.branch_name
            )
          );
          var prodsource = await dispatch(getProduct(indx.product));
          if (prodsource) {
            var newingredient = {
              ...indx,
              category: prodsource.category ? prodsource.category : "",
              category_name: prodsource.category_name
                ? prodsource.category_name
                : "",
              cost_peso: prodsource.cost_peso ? prodsource.cost_peso : 0,
              cost_rmb: prodsource.cost_rmb ? prodsource.cost_rmb : 0,
              sell_price: prodsource.sell_price ? prodsource.sell_price : 0,
              second_unit: prodsource.second_unit ? prodsource.second_unit : 0,
              unit: prodsource.unit ? prodsource.unit : "",
              quantity: indx.quantity,
            };

            save_ingredients.push(newingredient);
          } else {
            message.error(indx.product_name + " not found");
          }
          message.info(
            `(${i + 1}/${ingredient_final.length})  ${
              indx.product_name
            } updated`
          );
        })
      );

      var newsold = await dispatch(
        fixSaleNoIngredients(currentSalesOrder, products_sold, save_ingredients)
      );

      setLoading(false);
      closeModal("reset");
    }
  };

  const closeModal = (action) => {
    if (!loading) {
      setItemcount([]);
      onModalClose(action);
    }
  };

  return (
    <Popconfirm
      title="Are you sure you want to fix no ingredients?"
      onConfirm={() => {
        if (currentSalesOrder && menuitems?.length > 0) {
          summarizeSale();
        } else {
          message.error("no order");
        }
      }}
      okText="Yes"
      cancelText="No"
    >
      <Button type="primary" loading={loading}>
        fix no ingredients
      </Button>
    </Popconfirm>
  );
};

export default Index;
